import { createSlice } from '@reduxjs/toolkit';

const initialJourneyMapSliceState =
{
    journeyMap: [],
    stageActivities: []
};

const journeyMapSlice = createSlice({
    name: 'journeyMap',
    initialState: initialJourneyMapSliceState,
    reducers: {
        setJourneyMap(state, action) {
            state.journeyMap = action.payload;
        },

        setStageActivities(state, action) {
            //state.stageActivities = action.payload;

            let temp = [...action.payload] ;
            let tempObj = [...action.payload];
            tempObj = [];
            tempObj = temp.filter(x => x.activityTypeId != 6).sort((a, b) => a.sequence > b.sequence ? 1 : -1);
            state.stageActivities = tempObj;
        },

    },
});

export default journeyMapSlice;